import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import config from '../config';

class FirebaseClient {
  constructor() {
    const app = firebase.initializeApp(config.firebase);
    window.app = app;
    this.database = app.database();
    this.connectedRef = this.database.ref('.info/connected');
    this.auth = app.auth();
    this.googleProvider = new firebase.auth.GoogleAuthProvider();
  }

  signInWithGoogle() {
    return this.auth.signInWithPopup(this.googleProvider);
  }

  signOut() {
    return this.auth.signOut();
  }

  getToken(forceRefresh = false) {
    return this.auth.currentUser.getIdToken(forceRefresh);
  }

  onTokenChanged(callback) {
    this.auth.onIdTokenChanged(callback);
  }

  onConnectionStateChange(callback) {
    this.database.ref('.info/connected').on('value', snapshot => {
      if (snapshot.val() === true) {
        callback(true);
      } else {
        callback(false);
      }
    });
  }

  onVersionChanged(callback) {
    this.database.ref('version').on('value', snapshot => {
      callback(snapshot.val());
    });
  }

  onServerTimeOffsetChanged(callback) {
    this.database.ref('.info/serverTimeOffset').on('value', snap => {
      const offset = snap.val();
      callback(offset);
    });
  }

  onCustomerServiceAdminAccountsChanged(callback, errorHandler) {
    this.database.ref('customerService/adminAccounts').on(
      'value',
      snap => {
        const customerServiceAdminAccounts = snap.val();

        callback(customerServiceAdminAccounts);
      },
      errorHandler,
    );
  }
}

export default FirebaseClient;



// WEBPACK FOOTER //
// ./src/firebase/FirebaseClient.js